import { ToastType } from 'modules/application/misc/ToastService';
import { BlipToastDuration } from 'modules/shared/BlipToastService';
import { GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ACTIVE_MESSAGE_SCHEDULED_BUTTON_CLICKED, GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ACTIVE_MESSAGE_SENT_BUTTON_CLICKED, } from '../../GrowthSegmentEvents';
import { ActiveMessagesConstants } from '../ActiveMessagesConstants';
import { RedirectType } from '../models/RedirectType';
import { validateScheduledDate } from '../utils/campaignScheduleUtils';
import './EditScheduledCampaign.scss';
import { ActiveMessagesFeatures } from '../ActiveMessagesFeatures';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { FeatureToggleClientService } from 'feature-toggle-client';
import { blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostName, messaginghubWebsocketHostNameTenant, activeCampaignMfeSettingsSource, } from 'app.constants';
export class EditScheduledCampaignController {
    static $inject = ['LoadingService', 'ActiveMessageService', 'BlipToastService', 'GrowthSegmentService', '$stateParams', '$state', '$translate', 'AccountService2', 'ApplicationService2', 'AuthenticationService', 'TranslateService', 'application'];
    constructor(LoadingService, ActiveMessageService, BlipToastService, GrowthSegmentService, $stateParams, $state, $translate, AccountService2, ApplicationService2, AuthenticationService, TranslateService, application) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.ActiveMessageService = ActiveMessageService;
        this.BlipToastService = BlipToastService;
        this.GrowthSegmentService = GrowthSegmentService;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$translate = $translate;
        this.AccountService2 = AccountService2;
        this.ApplicationService2 = ApplicationService2;
        this.AuthenticationService = AuthenticationService;
        this.TranslateService = TranslateService;
        this.application = application;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.blipDomainUrl = blipDomainUrl;
        this.settingsSource = activeCampaignMfeSettingsSource;
        this.setScheduleButtonCampaign = (event) => {
            if (event.detail?.checked) {
                if (event.target?.id == 'instant-button') {
                    this.isScheduledCampaign = false;
                }
                else if (event.target?.id == 'scheduled-button') {
                    this.isScheduledCampaign = true;
                }
            }
        };
        this.setScheduleTime = (event) => {
            this.scheduleTime = event.detail?.value;
        };
        this.setScheduleData = (event) => {
            this.scheduleDate = event.detail?.value;
        };
        this.isScheduledCampaign = true;
    }
    async $onInit() {
        this.isEnabledActiveCampaignMFE = await ActiveMessagesFeatures.isEnabledActiveCampaignMFE();
        if (this.isEnabledActiveCampaignMFE) {
            await this.LoadActiveCampaignMfe();
        }
        else {
            this.LoadingService.startLoading(true);
            try {
                const campaignId = this.$stateParams.campaignId;
                this.campaign = await this.ActiveMessageService.getCampaign(campaignId);
                const campaignDate = new Date(this.campaign.scheduled);
                this.scheduleDate = this.addZero(campaignDate.getFullYear()) + '-' + this.addZero(campaignDate.getMonth() + 1) + '-' + this.addZero(campaignDate.getDate());
                this.scheduleTime = this.addZero(campaignDate.getHours()) + ':' + this.addZero(campaignDate.getMinutes()) + ':' + this.addZero(campaignDate.getSeconds());
            }
            catch (e) {
                console.error(e);
            }
            finally {
                this.LoadingService.stopLoading();
            }
        }
        this.LoadingService.stopLoading();
    }
    async LoadActiveCampaignMfe() {
        try {
            this.LoadingService.startLoading();
            const me = await this.AccountService2.me();
            const account = await this.ApplicationService2.getAccount();
            const userToken = this.AuthenticationService.token;
            const userEmail = encodeURIComponent(me.email);
            const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
            this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
            this.language = this.TranslateService.getCurrentLanguage();
            this.ownerIdentity = useDelegation ? `${userEmail}/${this.application.shortName}` : this.application.shortName;
            this.botIdentity = account.identity;
            this.token = useDelegation ? userToken : this.application.accessKey;
            this.authEmail = this.AuthenticationService.email;
            this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
            this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
            this.LoadingService.stopLoading();
            this.readyToRender = true;
        }
        catch (e) {
            console.error('LoadActiveCampaignMfe', e);
        }
    }
    goToGrowth() {
        this.$state.go(ActiveMessagesConstants.ACTIVE_MESSAGE_STATE, { reload: true });
    }
    async finishEdit() {
        this.campaign.scheduled = undefined;
        if (this.isScheduledCampaign) {
            if (!validateScheduledDate(this.scheduleDate, this.scheduleTime, this.BlipToastService, this.$translate)) {
                return;
            }
            this.campaign.scheduled = new Date(this.scheduleDate + ' ' + this.scheduleTime);
        }
        try {
            await this.ActiveMessageService.mergeScheduledCampaign(this.campaign);
            this.BlipToastService.show(ToastType.Success, {
                msg: await this.$translate('activeMessages.edit.toast.success.msg'),
                duration: BlipToastDuration.NO_TITLE.NO_ACTION,
            });
            const message = await this.ActiveMessageService.getMessage(this.campaign?.id);
            const messageTrack = message !== null && message.items && message.items[0]
                ? message.items[0] : undefined;
            const trackName = this.campaign?.scheduled ?
                GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ACTIVE_MESSAGE_SCHEDULED_BUTTON_CLICKED :
                GROWTH_ACTIVE_MESSAGE_WA_SEND_STEP_ACTIVE_MESSAGE_SENT_BUTTON_CLICKED;
            this.GrowthSegmentService.trackEvent(trackName, {
                action: 'edit',
                applicationOrigin: ActiveMessagesConstants.APPLICATION_ORIGIN,
                content: messageTrack?.messageTemplate || '',
                language: messageTrack?.messageTemplateLanguage || '',
                activeMessageType: this.campaign?.campaignType || '',
                shippingType: this.campaign?.scheduled ? 'Scheduled' : 'Now',
                campaignName: this.campaign?.name || '',
                scheduleDate: this.campaign?.scheduled ? new Date(this.scheduleDate + ' ' + this.scheduleTime) : undefined,
                scheduleTime: this.campaign?.scheduled ? this.scheduleTime : undefined,
                redirectType: this.campaign?.attendanceRedirect ? RedirectType.Agent : RedirectType.Flow,
                agentName: this.campaign?.attendanceRedirect ? decodeURIComponent(this.campaign.attendanceRedirect).replace('@blip.ai', '') : '',
                stateId: this.campaign?.stateId ?? '',
            });
            this.goToGrowth();
        }
        catch (e) {
            console.error(e);
            this.BlipToastService.show(ToastType.Danger, {
                title: await this.$translate('activeMessages.edit.toast.error.title'),
                msg: await this.$translate('activeMessages.edit.toast.error.msg'),
                duration: BlipToastDuration.WITH_TITLE.NO_ACTION,
            });
        }
    }
    addZero(nbr) {
        return nbr > 9 ? nbr : ('0' + nbr);
    }
}
EditScheduledCampaignController.$inject = ['LoadingService', 'ActiveMessageService', 'BlipToastService', 'GrowthSegmentService', '$stateParams', '$state', '$translate', 'AccountService2', 'ApplicationService2', 'AuthenticationService', 'TranslateService', 'application'];
